<template>
    <div>
        <form ref="form" class="contact-form__input-container">
            <input type="hidden" name="action" value="contact">
            <div class="contact-form__input-section">
                <label for="first-name" class="access-hidden" v-text="'First Name'"/>
                <input
                    v-model="formFeilds.firstName"
                    name="first-name"
                    id="first-name"
                    type="text"
                    placeholder="First Name"
                    class="contact-form__input contact-form__input_small contact-form__input_small--primary"
                    required
                >
                <label for="last-name" class="access-hidden" v-text="'Last Name'"/>
                <input
                    v-model="formFeilds.lastName"
                    id="last-name"
                    name="last-name"
                    type="text"
                    placeholder="Last Name"
                    class="contact-form__input contact-form__input_small contact-form__input_small contact-form__input_small--secondary"
                    required
                >
            </div>
            <label for="phone-number" class="access-hidden" v-text="'Phone Number'"/>
            <input
                v-model="formFeilds.phoneNumber"
                id="phone-number"
                name="phone-number"
                type="tel"
                class="contact-form__input contact-form__input_big"
                placeholder="Phone Number"
            >
            <label for="email" class="access-hidden" v-text="'Email'"/>
            <input
                v-model="formFeilds.email"
                id="email"
                name="email"
                type="email"
                placeholder="Email Address"
                class="contact-form__input contact-form__input_big"
                required
            >
            <label for="message" class="access-hidden" v-text="'Message'"/>
            <input
                v-model="formFeilds.message"
                id="message"
                name="message"
                type="text"
                class="contact-form__input contact-form__input_big contact-form__input__big-bottom"
                placeholder="Message"
            >
            <input
    			type="hidden"
    			name="g-recaptcha-response"
    			:value="recaptchaToken"
			/>
            <div class="contact-form__button-container">
                 <p
                    v-if="notValid"
                    v-text="options.form_error"
                    class="paragraph-01 contact-form__validity-copy"
                />
                <button
                    v-if="!success"
                    @click.prevent="submit()"
                    type="submit"
                    aria-pressed="false"
                    aria-describedby="submit-button"
                    class="contact-form__submit-btn"
                >
                    <span class="contact-form__submit-btn-text">{{ options.submit_button_text }}</span>
                </button>
                <div
                    v-if="success"
                    class="contact-form__submitted-container"
                >
                    <h3 class="paragraph-01" v-text="options.form_submit"/>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'contact-form',
    props: {
        options: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            success: null,
            notValid: null,
        	recaptchaToken: '',
            formFeilds: {
                email: undefined,
                message: undefined,
                lastName: undefined,
                firstName: undefined,
                phoneNumber: undefined,
            },
        };
    },
    methods: {
        async submit() {
            // HTML5 validity check
            if (!this.$refs.form.checkValidity()) {
                this.notValid = true;
                return;
            }

            try {
                // 1) Get reCAPTCHA token
                this.recaptchaToken = await this.getRecaptchaToken();

                // 2) Submit the form
                const formData = new FormData(this.$refs.form);

                await axios.post('/wp-admin/admin-ajax.php', formData);

                this.resetForm('success', 'notValid');
            } catch (e) {
                console.error(e);
                this.success = false;
            }
        },

        getRecaptchaToken() {
            return new Promise((resolve, reject) => {
                if (typeof window.grecaptcha === 'undefined') {
                    reject(new Error('reCAPTCHA not loaded'));
                    return;
                }

                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute('YOUR_SITE_KEY', { action: 'contact' })
                        .then(token => resolve(token))
                        .catch(err => reject(err));
                });
            });
        },

        resetForm(successful, unsuccessful) {
            this[successful] = true;
            this[unsuccessful] = false;

            if (this[successful]) {
                Object.keys(this.formFeilds).forEach((key) => {
                    this.formFeilds[key] = '';
                });
                this.recaptchaToken = '';
            }
    	},
	},
};
</script>



// WEBPACK FOOTER //
// ContactForm.vue?db854d2c